type IconProps = {
  color?: string;
  backgroundColor?: string;
  size?: number;
  className?: string;
  opacity?: number;
};

/** For use in nav/sidebar: inherits text color and 20px size */
export function IconSupplierForNav({
  className,
}: {
  className?: string;
}) {
  return (
    <IconSupplier className={className} color="currentColor" size={20} />
  );
}

export function IconSupplier({
  color = "#7B7876",
  opacity =0.4,
  backgroundColor,
  size = 24,
  className,
}: IconProps) {
  const bgColor = backgroundColor || color;

  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2812_80299)">
        <path
          opacity={opacity}
          d="M14.2321 1.25H5.7679C4.95506 1.24999 4.29944 1.24999 3.76853 1.29336C3.2219 1.33803 2.74175 1.43239 2.29754 1.65873C1.59193 2.01825 1.01825 2.59193 0.658726 3.29754C0.432386 3.74175 0.338026 4.2219 0.293364 4.76853C0.249987 5.29944 0.249993 5.95505 0.25 6.76788V15.2321C0.249993 16.0449 0.249987 16.7006 0.293364 17.2315C0.338026 17.7781 0.432386 18.2582 0.658726 18.7025C1.01825 19.4081 1.59193 19.9817 2.29754 20.3413C2.74175 20.5676 3.2219 20.662 3.76853 20.7066C4.29944 20.75 4.95505 20.75 5.76788 20.75H13.1265C13.3994 20.75 13.6508 20.6018 13.7828 20.3629C14.27 19.4819 15.0094 18.7454 15.9201 18.0902C16.083 17.973 16.1921 17.7954 16.2231 17.5971C16.254 17.3987 16.2042 17.1963 16.0847 17.035L15.783 16.6277C15.2907 15.9631 15 15.1423 15 14.25C15 12.0409 16.7909 10.25 19 10.25C19.4142 10.25 19.75 9.91421 19.75 9.5V6.76788C19.75 5.95505 19.75 5.29944 19.7066 4.76853C19.662 4.2219 19.5676 3.74175 19.3413 3.29754C18.9817 2.59193 18.4081 2.01825 17.7025 1.65873C17.2582 1.43239 16.7781 1.33803 16.2315 1.29336C15.7006 1.24999 15.0449 1.24999 14.2321 1.25Z"
          fill={color}
        />
        <path
          d="M6.12497 1.25H13.875V9.94329C13.875 10.5904 13.1104 10.9338 12.6267 10.5038L9.99997 8.16898L7.37325 10.5038C6.88957 10.9338 6.12497 10.5904 6.12497 9.94329V1.25Z"
          fill={bgColor}
        />
        <path
          d="M7.99997 16.25C8.41419 16.25 8.74997 15.9142 8.74997 15.5C8.74997 15.0858 8.41419 14.75 7.99997 14.75H5.5C5.08579 14.75 4.75 15.0858 4.75 15.5C4.75 15.9142 5.08579 16.25 5.5 16.25H7.99997Z"
          fill={bgColor}
        />
        <path
          d="M16.25 14.25C16.25 12.7312 17.4812 11.5 19 11.5C20.5188 11.5 21.75 12.7312 21.75 14.25C21.75 15.7688 20.5188 17 19 17C17.4812 17 16.25 15.7688 16.25 14.25Z"
          fill={color}
        />
        <path
          d="M14.5158 21.8754C15.0199 19.9168 16.921 18.5 19 18.5C21.0789 18.5 22.9801 19.9168 23.4842 21.8754C23.5227 22.0251 23.4898 22.1842 23.3951 22.3063C23.3004 22.4285 23.1546 22.5 23 22.5H15C14.8454 22.5 14.6995 22.4285 14.6048 22.3063C14.5101 22.1842 14.4772 22.0251 14.5158 21.8754Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2812_80299">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
